module.exports = __webpack_public_path__ + "img/3 lions.a0de96ef.png";